export var HttpMethod;
(function (HttpMethod) {
    HttpMethod["Trace"] = "TRACE";
    HttpMethod["Options"] = "OPTIONS";
    HttpMethod["Get"] = "GET";
    HttpMethod["Put"] = "PUT";
    HttpMethod["Post"] = "POST";
    HttpMethod["Delete"] = "DELETE";
})(HttpMethod || (HttpMethod = {}));
//# sourceMappingURL=http_method.js.map